import { render, staticRenderFns } from "./VerticalSteps.vue?vue&type=template&id=0a465c7c&scoped=true&"
import script from "./VerticalSteps.vue?vue&type=script&lang=js&"
export * from "./VerticalSteps.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSteps.vue?vue&type=style&index=0&id=0a465c7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a465c7c",
  null
  
)

export default component.exports